function getLoadingOverlay(text) {
    // `class`, not `className`: this is an HTML string handed to ag-grid, not JSX, so React's spelling
    // left the overlay unstyled. It went unnoticed because the one grid that reached it most often could
    // never show it — useGlobalBillingConfigs seeded `initialData`, which pins isLoading to false (CALL-794).
    return `<span class="ag-overlay-loading-center">${text}</span>`;
}

export default getLoadingOverlay;
